import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { trackEvent } from './tracking';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

// Types
type Props = {
  banner: string;
};

export const useBannerTracking = ({ banner }: Props) => {
  const { id: currentUserId } = useCurrentUser();
  const { appId } = useApp();

  const track = ({ eventName, properties = {} }) => {
    const propertiesToSend = {
      product_feature: 'Banners',
      user: currentUserId,
      app_id: appId,
      banner,
      ...properties,
    };

    trackEvent(eventName, propertiesToSend);
  };

  const trackPrimaryCTAClick = () => {
    track({
      eventName: 'Clicked Primary CTA',
    });
  };

  const trackLearnMoreClick = () => {
    track({
      eventName: 'Clicked Learn More',
    });
  };

  const trackDismissClick = () => {
    track({
      eventName: 'Clicked Dismiss',
    });
  };

  return {
    trackPrimaryCTAClick,
    trackLearnMoreClick,
    trackDismissClick,
  };
};
